import { UserRole } from '@/models/user'
import { RouteRecordRaw } from 'vue-router'

export enum InsightFilters {
  'Insight/Overview' = 'Overview',
  'Insight/OTIF' = 'OTIF',
  'Insight/Forecast' = 'Forecast'
}

export enum OrderFilters {
  'Order/Overview' = 'Overview',
  'Order/Pick' = 'Pick',
  'Order/Pack' = 'Pack'
}

export enum WarehouseOverviewFilters {
  // 'Warehouse/Dashboard' = 'Dashboard',
  // 'Warehouse/Tasks' = 'Tasks',
  'Warehouse/Locations' = 'Dashboard',
  'Warehouse/Receive' = 'Receive Deliveries',
  'Warehouse/StoreItems' = 'Store Items',
  'Warehouse/Move' = 'Look-up & Move',
  // 'Warehouse/Pick' = 'Pick',
}

// TODO add filter pages to Manage/Catalogues
enum CatalogueDataSourceFilters {
  // 'DataSource/Overview' = 'Overview',
  // 'DataSource/Sources' = 'Sources', // data flows bound to a catalogue, can also list "custom" maps for that source
  'DataSource/Maps' = 'Maps' // general maps by service (independant of catalogue)
}

export const ROOT_NAME = 'Root'
export const ROOT_OVERVIEW = 'OperationalDashboard'
export const AUTHED_INDEX = 'AppIndex'

// --- [ IMPORTANT NOTE ] ---
// since the AppIndex (or any similar route with children as views) will display one of the children below as a view by default
// you need to redirect to whichever you want the default to be
// for the child-navigation to work correctly (otherwise it will show items for children of AppIndex in this case)
// redirect: { name: ROOT_OVERVIEW },

// const rootChildren = [
//   {
//     path: 'overview',
//     component: () => import('pages/Dashboard/Overview.vue'),
//     name: ROOT_OVERVIEW,
//     meta: {
//       title: 'Dashboard'
//     }
//   },
//   {
//     path: 'orders',
//     component: () => import('pages/Dashboard/Orders.vue'),
//     name: 'DashboardOrders',
//     meta: {
//       isView: true,
//       filters: OrderFilters,
//       title: 'Orders'
//       // roles: [UserRole.OperationalManager, UserRole.WarehouseManager, UserRole.Picker, UserRole.Packer]
//     }
//   },
//   {
//     path: 'insights',
//     component: () => import('pages/Dashboard/Insights.vue'),
//     name: 'DashboardInsights',
//     meta: {
//       isView: true,
//       filters: InsightFilters,
//       title: 'Insights'
//       // roles: [UserRole.OperationalManager, UserRole.WarehouseManager]
//     }
//   }
// ]

const index = {
  path: '/',
  // component: () => import('pages/Dashboard/Index.vue'),
  name: AUTHED_INDEX,
  // IMPORTANT NOTE
  // since the AppIndex (or any similar route with children as views) will display one of the children below as a view by default
  // you need to redirect to whichever you want the default to be
  // for the child-navigation to work correctly (otherwise it will show items for children of AppIndex in this case)
  // redirect: {name: ROOT_OVERVIEW},
  // name: ROOT_OVERVIEW,
  component: () => import('pages/Dashboard/Orders.vue'),
  meta: {
    isView: true,
    filters: OrderFilters,
    title: 'Fulfillment',
    // icon: 'icon-catalogue',
  },
  // children: rootChildren
}
const insights = {
  path: '/insight',
  component: () => import('pages/Dashboard/Insight/Overview.vue'),
  name: 'Insights',
  meta: {
    title: 'Insights',
    // isView: true,
    // filters: InsightFilters,
    roles: [UserRole.OperationalManager, UserRole.WarehouseManager]
  }
}

// const products = {
//   path: '/manage/products',
//   name: 'Products',
//   component: () => import('pages/Manage/Products/Index.vue'),
//   redirect: { name: 'ManageProductsOverview' },
//   meta: {
//     title: 'Products',
//     roles: [UserRole.ProductManager, UserRole.OperationalManager]
//   },
//   children: [
//     {
//       path: 'overview',
//       component: () => import('pages/Manage/Products/Overview.vue'),
//       name: 'ManageProductsOverview',
//       meta: {
//         title: 'Overview'
//       }
//     },
//     {
//       path: 'categories',
//       component: () => import('pages/Manage/Products/Categories.vue'),
//       name: 'ManageProductCategories',
//       meta: {
//         title: 'Categories'
//       }
//     }
//   ]
// }

const issueTracker = {
  path: '/issue-tracker',
  name: 'IssueTracker',
  meta: {
    title: 'Issue Tracker',
    roles: [UserRole.Admin, UserRole.OperationalManager]
  },
  component: () => import('pages/Dashboard/IssueTracker/IssueTrackerIndex.vue'),
}

const products = {
  path: '/products',
  name: 'Products',
  component: () => import('pages/Products/Index.vue'),
  redirect: { name: 'ProductsOverview' },
  meta: {
    title: 'Products',
    roles: [UserRole.ProductManager, UserRole.OperationalManager]
  },
  children: [
    {
      path: 'overview',
      component: () => import('pages/Products/ProductsOverview.vue'),
      name: 'ProductsOverview',
      props: route => ({
        page: route.query.page ? parseInt(route.query.page) : undefined,
        pageSize: route.query.pageSize ? parseInt(route.query.pageSize) : undefined
      }),
      meta: {
        title: 'Products',
        disableRouteTabNav: true
      }
    },
    {
      path: ':productId/:creating?',
      name: 'ProductDetailIndex',
      component: () => import('pages/Products/ProductDetail/Index.vue'),
      props: true,
      meta: {
        title: 'Product details',
        disableRouteTabNav: true,
      }
    }
  ]
}

const inventory = {
  path: '/manage/inventory',
  name: 'Inventory',
  component: () => import('pages/Manage/Inventory/Index.vue'),
  redirect: { name: 'ManageInventoryOverview' },
  meta: {
    title: 'Warehouse',
    roles: [UserRole.OperationalManager, UserRole.WarehouseManager]
  },
  children: [
    {
      path: 'overview',
      component: () => import('pages/Manage/Inventory/Overview.vue'),
      name: 'ManageInventoryOverview',
      meta: {
        isView: true,
        filters: WarehouseOverviewFilters,
        title: 'Warehouse Dashboard'
      }
    },
    // {
    //   path: 'stock',
    //   component: () => import('pages/Manage/Inventory/Stock.vue'),
    //   name: 'ManageInventoryStock',
    //   meta: {
    //     title: 'Stock'
    //   }
    // },
    // {
    //   path: 'locations/storage',
    //   component: () => import('pages/Manage/Inventory/StorageLocations.vue'),
    //   name: 'ManageStorageLocations',
    //   meta: {
    //     title: 'Warehouses'
    //   }
    // },
    // {
    //   path: 'locations/inventory',
    //   component: () => import('pages/Manage/Inventory/InventoryLocations.vue'),
    //   name: 'ManageInventoryLocations',
    //   meta: {
    //     title: 'Inventory Locations'
    //   }
    // },
    // {
    //   path: 'locations/packing',
    //   component: () => import('pages/Manage/Inventory/Packing.vue'),
    //   name: 'ManagePacking',
    //   meta: {
    //     title: 'Packing'
    //   }
    // },
    // {
    //   path: 'locations/storage-types',
    //   component: () => import('pages/Manage/Inventory/StorageType.vue'),
    //   name: 'ManageStorageTypes',
    //   meta: {
    //     title: 'Storage Types'
    //   }
    // },
    // {
    //   path: 'props',
    //   component: () => import('pages/Manage/Inventory/ItemProperties.vue'),
    //   name: 'ManageItemProps',
    //   meta: {
    //     title: 'Item Properties'
    //   }
    // }
  ]
}

// const catalogues = {
//   path: '/manage/catalogues',
//   name: 'Catalogues',
//   component: () => import('pages/Manage/Catalogues/Index.vue'),
//   redirect: {name: 'ManageCataloguesOverview'},
//   meta: {
//     title: 'Catalogues',
//     roles: [UserRole.OperationalManager, UserRole.ClientManager, UserRole.Financial]
//   },
//   children: [
//     {
//       path: 'overview',
//       component: () => import('pages/Manage/Catalogues/Overview.vue'),
//       name: 'ManageCataloguesOverview',
//       meta: {
//         title: 'Overview'
//       }
//     },
//     {
//       path: 'clients',
//       component: () => import('pages/Invoice/Clients.vue'),
//       name: 'CatalogueManageClients',
//       meta: {
//         title: 'Clients'
//       }
//     },
//     {
//       path: 'stock',
//       component: () => import('pages/Manage/Catalogues/Stock.vue'),
//       name: 'ManageCatalogueStock',
//       meta: {
//         title: 'Stock',
//         roles: [UserRole.OperationalManager, UserRole.WarehouseManager]
//       }
//     },
//     {
//       path: 'data-sources',
//       component: () => import('pages/Manage/Catalogues/DataSources.vue'),
//       name: 'ManageCatalogueDataSources',
//       meta: {
//         isView: true,
//         filters: CatalogueDataSourceFilters,
//         title: 'Data Sources',
//         roles: [UserRole.OperationalManager, UserRole.ClientManager]
//       }
//     }
//   ]
// }

const channels = {
  path: '/channels',
  name: 'channels',
  component: () => import('pages/Channels/Index.vue'),
  redirect: { name: 'Channels' },
  meta: {
    title: 'Channels',
    roles: [UserRole.OperationalManager, UserRole.Client, UserRole.ClientManager, UserRole.Financial]
  },
  children: [
    {
      path: ':channelId?',
      props: true,
      component: () => import('pages/Channels/ChannelOverview.vue'),
      name: 'Channels',
      meta: {
        title: 'Channels',
        disableRouteTabNav: true
      },
    },
    {
      path: 'clients/:clientId?',
      props: true,
      component: () => import('pages/Channels/ClientOverview.vue'),
      name: 'Clients',
      meta: {
        title: 'Clients',
        roles: [UserRole.OperationalManager, UserRole.ClientManager, UserRole.Financial],
        disableRouteTabNav: true
      },
    },
  ],
}

const suppliers = {
  path: '/suppliers',
  name: 'suppliers',
  component: () => import('pages/WIP/Index.vue'),
  redirect: { name: 'Suppliers' },
  meta: {
    title: 'Suppliers',
    roles: [UserRole.OperationalManager, UserRole.ClientManager, UserRole.Financial]
  },
  children: [
    {
      path: ':supplierCatalogueId?',
      props: true,
      component: () => import('pages/WIP/SupplierCatalogueOverview.vue'),
      name: 'SupplierCatalogues',
      meta: {
        title: 'Supplier Catalogues',
        disableRouteTabNav: true
      },
    },
    {
      path: 'supplier/:supplierId?',
      props: true,
      component: () => import('pages/WIP/SupplierOverview.vue'),
      name: 'Suppliers',
      meta: {
        title: 'Supplier',
        disableRouteTabNav: true
      },
    },
    {
      path: 'orders/:id?',
      component: () => import('pages/Suppliers/Orders.vue'),
      name: 'SupplyOrders',
      meta: {
        title: 'Supply Orders',
        disableRouteTabNav: true
      }
    }
  ],
}

const sourcing = {
  path: '/sourcing',
  name: 'Sourcing',
  component: () => import('pages/Suppliers/Index.vue'),
  redirect: { name: 'SupplierCatalogueOverview' },
  meta: {
    title: 'Sourcing',
    roles: [UserRole.OperationalManager, UserRole.WarehouseManager]
  },
  children: [
    {
      path: 'catalogue',
      component: () => import('pages/Suppliers/Overview.vue'),
      name: 'SupplierCatalogueOverview',
      meta: {
        title: 'Overview'
      }
    },
    {
      path: 'supplier',
      component: () => import('pages/Suppliers/Supplier.vue'),
      name: 'SourcingSuppliers',
      meta: {
        title: 'Suppliers'
      }
    },
    {
      path: 'orders',
      component: () => import('pages/Suppliers/Orders.vue'),
      name: 'SourceOrders',
      meta: {
        title: 'Supply Orders'
      }
    }
    // {
    //   path: 'data-sources',
    //   component: () => import('pages/Suppliers/DataSources.vue'),
    //   name: 'SuppliersDataSources',
    //   meta: {
    //     title: 'Data Sources'
    //   }
    // }
  ]
}

const invoicing = {
  path: '/financial',
  name: 'Financial',
  component: () => import('pages/Invoice/Index.vue'),
  redirect: { name: 'CreateInvoice' },
  meta: {
    title: 'Financial',
    roles: [UserRole.Financial]
  },
  children: [
    {
      path: 'invoice',
      component: () => import('pages/Invoice/CreateInvoice.vue'),
      name: 'CreateInvoice',
      meta: {
        title: 'Create Invoice'
      }
    }
  ]
}

const importing = {
  path: '/import',
  name: 'Import',
  component: () => import('pages/Import/Index.vue'),
  redirect: { name: 'ImportOverview' },
  meta: {
    title: 'Import',
    roles: [UserRole.OperationalManager]
  },
  children: [
    {
      path: 'overview',
      component: () => import('pages/Import/Overview.vue'),
      name: 'ImportOverview',
      meta: {
        title: 'Import'
      }
    }
    // {
    //   path: 'history',
    //   component: () => import('pages/Import/History.vue'),
    //   name: 'ImportHistory',
    //   meta: {
    //     title: 'History'
    //   }
    // },
    // {
    //   path: 'maps',
    //   component: () => import('pages/Import/Maps.vue'),
    //   name: 'ManageCatalogueMaps',
    //   meta: {
    //     title: 'Maps'
    //   }
    // }
  ]
}

// const settings = {
//   path: '/settings',
//   name: 'settings',
//   component: () => import('pages/Settings/Index.vue'),
//   redirect: { name: 'SettingsOverview' },
//   meta: {
//     title: 'Settings',
//     roles: [UserRole.Admin]
//   },
//   children: [
//     {
//       path: 'overview',
//       component: () => import('pages/Settings/Overview.vue'),
//       name: 'SettingsOverview',
//       meta: {
//         title: 'Overview'
//       }
//     },
//     {
//       path: 'me',
//       component: () => import('pages/Settings/Me.vue'),
//       name: 'SettingsAccountMe',
//       meta: {
//         title: 'Me'
//       }
//     },
//     {
//       path: 'ozone',
//       component: () => import('pages/Settings/Ozone.vue'),
//       name: 'SettingsOzone',
//       meta: {
//         title: 'Application'
//         // TODO: user settings are now in here, but should be on a separate route
//       }
//     },
//     {
//       path: 'users',
//       component: () => import('pages/Settings/Users.vue'),
//       name: 'SettingsUsers',
//       meta: {
//         title: 'Users',
//         roles: [UserRole.Admin]
//       }
//     },
//     {
//       path: 'services',
//       component: () => import('pages/Settings/Services.vue'),
//       name: 'SettingsServices',
//       meta: {
//         title: 'Services',
//         roles: [UserRole.SuperAdmin]
//       }
//     }
//   ]
// }


const v2Settings = {
  path: '/settings',
  name: 'settings',
  component: () => import('pages/NewSettings/Index.vue'),
  redirect: { name: 'MySettings' },
  meta: {
    title: 'Settings',
  },
  children: [
    {
      path: 'my-settings',
      component: () => import('pages/NewSettings/components/MySettings/MySettings.vue'),
      name: 'MySettings',
      meta: {
        title: 'My settings'
        // TODO: user settings are now in here, but should be on a separate route
      }
    },
    {
      path: 'company-settings',
      component: () => import('pages/NewSettings/components/CompanySettings/CompanySettings.vue'),
      name: 'CompanySettings',
      meta: {
        title: 'Company settings',
        roles: [UserRole.Admin]
      }
    },
    {
      path: 'manage-users',
      component: () => import('pages/NewSettings/components/ManageUsers/ManageUsers.vue'),
      name: 'ManageUsers',
      meta: {
        title: 'Manage users',
        roles: [UserRole.Admin]
      }
    },
    {
      path: 'service-info',
      component: () => import('pages/Settings/Services.vue'),
      name: 'Servuces',
      meta: {
        title: 'Services',
        roles: [UserRole.Admin]
      }
    },
    // {
    //   path: 'billing',
    //   component: () => import('pages/NewSettings/components/BillingSettings/BillingSettings.vue'),
    //   name: 'BillingSettings',
    //   meta: {
    //     title: 'Billing',
    //     roles: [UserRole.Admin]
    //   }
    // },
  ]
}

export const authedRoutes: Array<RouteRecordRaw> = [
  index,
  channels,
  products,
  inventory,
  // catalogues,
  suppliers,
  // sourcing,
  invoicing,
  importing,
  // settings,
  issueTracker,
  insights,
  v2Settings,
]

const authedRoot: RouteRecordRaw = {
  path: '/',
  component: () => import('layouts/Main.vue'),
  name: ROOT_NAME,
  meta: {
    requiresAuth: true
  }
}


const staticRoutes: Array<RouteRecordRaw> = [
  authedRoot,
  {
    path: '/login',
    component: () => import('pages/Login.vue'),
    name: 'Login'
  },
  {
    path: '/:pathMatch(.*)*',
    component: () => import('pages/Error404.vue')
  }
]

export default {
  static: staticRoutes,
  authed: authedRoutes,
  authedRoot,
  ROOT_NAME,
  AUTHED_INDEX,
  ROOT_OVERVIEW
}
